define([
    'require',
    './_site',
    './window',
    './field',
], function(
    require,
    Site,
    Wdw,
    Field
) {
    var _self;
    // console.log('form');

    // circular dependencies
    Form = require(['./field'], function(foo) {
        Field = foo;
    });

    // obj
    _self = {
        send: function ($el) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $submitAux = $submit.children('span'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('action'),
                data = _self.cycleBlocks($form),
                flag = false,
                submitClass = 'form__submit',
                spinner = $.extend(true, {}, Site.spin),
                // extra
                address = {
                    // address: $submit.data('address')
                    address: $form.find('.delivery_address').data('address')
                };

            function toggleLoader(flag) {
                if (flag) {
                    // add loader
                    $submit.addClass(submitClass + '--loading');
                    $submitAux.spin(spinner);
                } else {
                    // remove loader
                    $submit.removeClass(submitClass + '--loading');
                    $submitAux.spin(false);
                }
            }

            // prevent multiple clicks
            if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
                return false;
            }

            // validation errors
            if (!_self.checkFields($form, true)) {
                return false;
            }

            // address
            $.extend(data, address);

            console.log(data);

            // send data
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                cache: false,
                dataType: 'json',
                beforeSend: function () {
                    // add loader
                    toggleLoader(true);
                },
                success: function (response) {
                    console.log(response);

                    if (response.status) {

                        if (typeof(response.render) != "undefined" && response.render) {
                            // create alert
                            $('.questionnaire-render').replaceWith(response.render);

                            Field.testValue($('input, select, textarea'));
                        }
                        if (response.message) {
                            // create alert
                            Wdw.createAlert(response, 'success');
                        }
                        if (response.url) {
                            window.location.href = response.url;
                            return;
                        }
                    } else {
                        // create alert
                        Wdw.createAlert(response, 'error');
                    }

                    // remove loader
                    toggleLoader(false);
                },
                error: function (response) {
                    // create alert
                    Wdw.createAlert(response, 'error');

                    // remove loader
                    toggleLoader(false);
                }
            });
        },
        save: function ($el, requireRender) {
            var $submit = $el,
                $form = $submit.closest('.form'),
                $submitAux = $submit.children('span'),
                $fields = $form.find('input, select, textarea'),
                url = $form.data('action-save'),
                data = _self.cycleBlocks($form),
                flag = false,
                formClass = 'form',
                submitClass = 'form__submit',
                spinner = $.extend(true, {}, Site.spin),
                // extra
                address = {
                    // address: $submit.data('address')
                    address: $form.find('.delivery_address').data('address')
                },
                // get the id of focused element
                focusedElementID = $(':focus').attr('id');

            if(typeof(focusedElementID) == 'undefined') {
                setTimeout(function() {
                    var $focusedLabel = $form.find('.field--focus'),
                        $focusedFields = $focusedLabel.find('input, select, textarea');

                    if($focusedFields.length) {
                        focusedElementID = $focusedFields.first().attr('id');
                    }
                }, 1);
            }

            function toggleLoader(flag) {
                if (flag) {
                    // add loader
                    $form.addClass(formClass + '--loading');
                    // $fields.attr('readonly', 'readonly');
                    // $submitAux.spin(spinner);
                } else {
                    // remove loader
                    $form.removeClass(formClass + '--loading');
                    // $fields.removeAttr('readonly');
                    // $submitAux.spin(false);
                }
            }

            setTimeout(function() {
                // prevent multiple clicks
                if ($submit.hasClass(submitClass + '--loading') || $submit.hasClass('button--disabled')) {
                    return false;
                }

                // address
                $.extend(data, address);

                // render
                $.extend(data, {
                    render: requireRender
                });

                console.log(data);

                // send data
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: data,
                    cache: false,
                    dataType: 'json',
                    beforeSend: function () {
                        if (requireRender) {
                            // add loader
                            toggleLoader(true);
                        }
                    },
                    success: function (response) {
                        console.log(response);

                        var $renderContainer = $('.questionnaire-render');

                        if (response.status) {

                            if (requireRender) {

                                if (typeof(response.render) != "undefined" && response.render) {

                                    if ($renderContainer.html() != response.render) {

                                        // remove loader
                                        // toggleLoader(false);

                                        // create alert
                                        $renderContainer.replaceWith(response.render);

                                        // set focus on the new element
                                        console.log('Trying to focus: #' + focusedElementID);
                                        var $newElement = $('#' + focusedElementID);
                                        if ($newElement.length) {
                                            $newElement.focus();
                                            console.log('Focused! #' + focusedElementID);
                                        }

                                        Field.testValue($('input, select, textarea'));
                                    }

                                }

                            }

                            if (response.message) {
                                // create alert
                                Wdw.createAlert(response, 'success');
                            }

                        } else {
                            // create alert
                            Wdw.createAlert(response, 'error');
                        }

                        // remove loader
                        toggleLoader(false);
                    },
                    error: function (response) {
                        // create alert
                        Wdw.createAlert(response, 'error');

                        // remove loader
                        toggleLoader(false);
                    }
                });

            }, 5);
        },
        traverseObject: function(data) {
            var prop,
                prop2;
            for (prop in data) {
                if (typeof data[prop] === 'object') {
                    _self.traverseObject(data[prop]);
                    // verify if has array
                    for (prop2 in data[prop]) {
                        if (prop2.indexOf(prop) > -1) {
                            // object to array
                            data[prop] = $.map(data[prop], function(value, index) {
                                return [value];
                            });
                            break;
                        }
                    }
                }
            }
        },
        getDataKey: function(data, block) {
            var aux = {},
                key;
            block = block.parent().closest('[data-block]');
            if (block.length && block.closest('.form').length) {
                key = (block.data('block') || null);
                if (key === null) {
                    aux = data;
                } else {
                    aux[key] = data;
                }
                return _self.getDataKey(aux, block);
            } else {
                return data;
            }
        },
        checkRequiredFields: function ($form) {
            var $fields = $form.find('input[required], textarea[required], select[required]'),
                $blocks = $form.find('[data-block]'),
                flag = false,
                $submit = $form.find('.form__submit:last');

            $fields.each(function() {
                var $input = $(this),
                    $b = $input.closest('[data-block]').not($form),
                    value = $input.val();

                // not visible
                if ($b.length && !$b.is(':visible')) {
                    return;
                }

                // no value set
                if (value === '' || value === null) {
                    flag = true;
                    return false;
                }
            });

            return flag;
        },
        toggleSubmit: function ($form) {
            var flag = _self.checkRequiredFields($form);

            if (!flag) {
                $submit.removeClass('button--disabled form__submit--disabled').removeAttr('disabled');
            }
            else {
                $submit.addClass('button--disabled form__submit--disabled').attr('disabled', 'disabled');
            }
        },
        checkIgnoreBlock: function($ignore, $input) {
            if ($input.closest($ignore).length) {
                return true;
            }
            return false;
        },
        checkFields: function($form, alert) {
            var $fields = $form.find('input:visible, textarea:visible, select:visible').not('[type=submit]'),
                flag = true;

            // cycle fields
            $fields.each(function() {
                var $input = $(this),
                    $inputGroup = $input.closest('.field__group'),
                    $wrapper = $input.parent(),
                    value = $input.val(),
                    name = $input.attr('name'),
                    message,
                    $alert = $('<div />').addClass('field__alert');

                // remove old alert
                if (alert) {
                    if($input.is('[data-ranking]')) {
                        Field.removeAlert($inputGroup.find('.field:last-child'));
                    }
                    else {
                        Field.removeAlert($wrapper);
                    }
                }

                if (!Field.checkValue($input)) {
                    flag = false;
                    message = $input.data('alert') || 'This field is required.';
                    $alert.text(message);

                    // append alert
                    if (alert) {
                        if($input.is('[data-ranking]')) {
                            Field.appendAlert($inputGroup.find('.field:last-child'), $alert);
                        }
                        else {
                            Field.appendAlert($wrapper, $alert);
                        }
                    }
                }
            });

            return flag;
        },
        cycleBlocks: function($form) {
            var data = {},
                $fields = $form.find('input, select, textarea'),
                $blocks = $form.find('[data-block]'),
                $ignore = $($form.data('ignore'));

            // cycle fields
            $fields.each(function() {
                var $input = $(this),
                    d = {},
                    v = $input.val(),
                    n = $input.attr('name'),
                    $b = $input.closest('[data-block]').not($form),
                    k = ($b.data('block') || null),
                    $opt = {
                        el: this
                    },
                    $aux,
                    $field,
                    isRanking = $input.attr('data-ranking');

                // ignored
                if (_self.checkIgnoreBlock($ignore, $input)) {
                    return;
                }
                // not visible
                if ($b.length && !$b.is(':visible')) {
                    return;
                }

                // get value
                if (k === null) {
                    if (typeof isRanking !== typeof undefined && isRanking !== false) {
                        d[n] = Field.getCheckboxRankingCheck($input);
                    }
                    else {
                        d[n] = Field.getCheckboxRadioCheck($input);
                    }
                } else {
                    d[k] = {};

                    if (typeof isRanking !== typeof undefined && isRanking !== false) {
                        d[k][n] = Field.getCheckboxRankingCheck($input);
                    }
                    else {
                        d[k][n] = Field.getCheckboxRadioCheck($input);
                    }
                }

                // get key
                d = _self.getDataKey(d, $b);

                // copy data
                $.extend(true, data, d);
            });

            // objects to array
            _self.traverseObject(data);

            // return data
            return data;
        },
        scrollToAlert: function($form, offset) {
            Wdw.scrollTo($form.find('.field__alert').first().offset().top, offset);
        },
        focusFirstField: function ($form) {
            var $input = $form.find('.field__input:visible').first();
            if ($input.length) {
                $input.trigger('focus');
            }
        }
    };


    // -------------------
    // BINDS
    // -------------------

    // ---------------- partial send form on change
    $('body').on('change', '[data-update-questionnaire]', function (event) {
        event.preventDefault();

        var $el = $(this),
            requireRender = ($el.data('require-render')) ? true : false,
            $form = $el.closest('form'),
            $submit = $form.find('[data-send-questionnaire]');

        if($submit.length) {
            _self.save($submit.first(), requireRender);
        }
    });

    // ---------------- send form
    $('body').on('click', '[data-send-questionnaire]', function (event) {
        event.preventDefault();
        _self.send($(this));
    });

    return _self;
});
